import React, { Fragment, useEffect, useState } from 'react';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import { Row, Col, Table, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faProcedures, faCrutch, faWheelchair, faHeadSideCough, faPlusSquare, faAmbulance, faLungs
} from "@fortawesome/free-solid-svg-icons";

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const styles = theme => ({
    disabled: {
        color: 'rgba(0, 0, 0, 0.87)',
        width: '175px'
    },

});


const EspecialRequirementsModal = ({ openEspReq, closeEspReq, dataReqEsp, reqEspData }) => {

    const [reqEspch1, setReqEspch1] = useState({ hospitalizado: false });
    const [reqEspch2, setReqEspch2] = useState({ sillas: false });
    const [reqEspch3, setReqEspch3] = useState({ muletas: false });
    const [reqEspch4, setReqEspch4] = useState({ sintomas_respiratorios: false });
    const [reqEspch5, setReqEspch5] = useState({ oxigeno: false });
    const [reqEspch6, setReqEspch6] = useState({ camilla: false });
    const [reqEspch7, setReqEspch7] = useState({ ambulancia: false });
    const [reqEspch8, setReqEspch8] = useState({ ninguno: false });
    const [reqEspch9, setReqEspch9] = useState({ otro: false, otroReq: '' });
    const [disabledChecks, setDisabledChecks] = useState(false);

    useEffect(() => {
        validateData();
    }, []);

    const validateData = () => {
        if (reqEspData.requerimientos_especiales != undefined) {
            setReqEspch1({ hospitalizado: reqEspData.requerimientos_especiales.hospitalizado });
            setReqEspch2({ sillas: reqEspData.requerimientos_especiales.sillas });
            setReqEspch3({ muletas: reqEspData.requerimientos_especiales.muletas });
            setReqEspch4({ sintomas_respiratorios: reqEspData.requerimientos_especiales.sintomas_respiratorios });
            setReqEspch5({ oxigeno: reqEspData.requerimientos_especiales.oxigeno })
            setReqEspch6({ camilla: reqEspData.requerimientos_especiales.camilla })
            setReqEspch7({ ambulancia: reqEspData.requerimientos_especiales.ambulancia });
            setReqEspch8({ ninguno: reqEspData.requerimientos_especiales.ninguno });
            setReqEspch9({ otro: reqEspData.requerimientos_especiales.otro, otroReq: reqEspData.requerimientos_especiales.otroReq })
        }
    }


    const saveReqEsp = () => {
        var requerimientos_especiales = {
            hospitalizado: reqEspch1.hospitalizado,
            sillas: reqEspch2.sillas,
            muletas: reqEspch3.muletas,
            sintomas_respiratorios: reqEspch4.sintomas_respiratorios,
            oxigeno: reqEspch5.oxigeno,
            camilla: reqEspch6.camilla,
            ambulancia: reqEspch7.ambulancia,
            ninguno: reqEspch8.ninguno,
            otro: reqEspch9.otro,
            otroReq: reqEspch9.otroReq
        }
        dataReqEsp(requerimientos_especiales);
        return;
    }
    return (
        <Fragment>
            <Modal
                open={openEspReq}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 1000 }}
            >

                <div className="paperAppointment-default">
                    <div>
                        <h4>Requerimientos Especiales</h4>
                    </div>
                    <div style={{ margin: 5 }}>
                        <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }, shrink: true, margin: 10
                            }}
                            style={{ marginBottom: 20 }}
                        >
                            <FormGroup style={{ width: '100%', margin: 5 }}>
                                <Row >
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faPlusSquare} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox
                                                    color="default"
                                                    disabled={disabledChecks}
                                                    checked={reqEspch1.hospitalizado}
                                                    onChange={(e) => {
                                                        setReqEspch1({ hospitalizado: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }} />
                                            }
                                            label="Hospitalizado"
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faWheelchair} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox
                                                    checked={reqEspch2.sillas}
                                                    disabled={disabledChecks}
                                                    onChange={(e) => {
                                                        setReqEspch2({ sillas: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    color="default" />
                                            }
                                            label="Sillas de ruedas"
                                        />

                                    </Col>
                                    {/* <Col md={4}>
                                        <FontAwesomeIcon icon={faCrutch} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch3({ muletas: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch3.muletas}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Muletas" />
                                    </Col> */}
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faHeadSideCough} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch4({ sintomas_respiratorios: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch4.sintomas_respiratorios}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Sintomas respitarios (Covid)" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faLungs} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch5({ oxigeno: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch5.oxigeno}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Oxigeno" />
                                    </Col>
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faProcedures} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch6({ camilla: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch6.camilla}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Camilla" />
                                    </Col>
                                    <Col md={4}>
                                        <FontAwesomeIcon icon={faAmbulance} style={{ margin: '0px 5px 0px 5px', width: 30, color: '#1086e0' }} />
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch7({ ambulancia: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch7.ambulancia}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Ambulancia" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch9({ otro: e.target.checked })
                                                        setReqEspch8({ ninguno: false })
                                                    }}
                                                    checked={reqEspch9.otro}
                                                    disabled={disabledChecks}
                                                />}
                                            label="Otro"
                                            style={{ marginLeft: 30 }} />
                                    </Col>
                                    <Col md={4}>
                                        {reqEspch9.otro == true ?
                                            <TextField
                                                id="another_requiriment"
                                                label="Otro Requerimiento"
                                                type="text"
                                                style={{ marginLeft: 30 }}
                                                value={reqEspch9.otroReq}
                                                onChange={(e) => {
                                                    setReqEspch9({ ...reqEspch9, otroReq: e.target.value })
                                                }}
                                            /* error={this.state.errors.hasOwnProperty("documentNumber") ? this.state.errors.documentNumber !== "" : false}
                                            helperText={this.state.errors.documentNumber} */
                                            //disabled={typeof this.props.dataPatient.cita !== 'undefined'}
                                            //disabled={this.state.disabledInput}
                                            />
                                            : null}

                                    </Col>
                                    <Col md={4}>
                                        <FormControlLabel
                                            control={
                                                <MedicalCheckbox color="default"
                                                    onChange={(e) => {
                                                        setReqEspch8({ ninguno: e.target.checked })
                                                        setReqEspch9({ otro: false })   
                                                        setReqEspch7({ ambulancia: false })
                                                        setReqEspch6({ camilla: false })
                                                        setReqEspch5({ oxigeno: false })
                                                        setReqEspch4({ sintomas_respiratorios: false })
                                                        setReqEspch3({ muletas: false })
                                                        setReqEspch2({ sillas: false })
                                                        setReqEspch1({ hospitalizado: false })
                                                        setDisabledChecks(!disabledChecks)
                                                    }}
                                                    checked={reqEspch8.ninguno}
                                                />}
                                            label="Ninguno"
                                            style={{ marginLeft: 30 }} />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </FormControl>
                    </div>

                    <div style={{ marginTop: 10, display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginRight: 10, marginLeft: 10 }}
                            variant="contained"
                            onClick={() => {
                                closeEspReq();
                            }}
                        >
                            Cerrar
                        </Button>
                        <Button
                            style={{ marginRight: 10, marginLeft: 10 }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                saveReqEsp();
                                closeEspReq();
                            }}
                        >
                            Guardar
                        </Button>
                    </div>
                </div>


            </Modal>
        </Fragment>
    );


}


export default EspecialRequirementsModal;